(function () {
  const CART_DOMAIN = 'https://v-milano.com';

  const COPY = {
    de: {
      checkout: 'Zur Kasse',
      redirecting: 'Weiterleitung …',
      error: 'Etwas ist schiefgelaufen. Bitte versuche es erneut.',
      unavailable: 'Dieses Produkt ist nicht verfügbar.',
      partial: 'Nicht alle Artikel sind im Checkout verfügbar. Bitte kontaktiere uns.'
    },
    en: {
      checkout: 'Checkout',
      redirecting: 'Redirecting…',
      error: 'Something went wrong. Please try again.',
      unavailable: 'This product is not available.',
      partial: 'Not all items are available at checkout. Please contact us.'
    },
    nl: {
      checkout: 'Afrekenen',
      redirecting: 'Wordt doorgestuurd...',
      error: 'Er ging iets mis, probeer opnieuw',
      unavailable: 'Dit product is niet beschikbaar',
      partial: 'Niet alle artikelen zijn beschikbaar. Neem contact met ons op.'
    }
  };

  function checkoutContext(){
    var supplied = window.VM_CHECKOUT_CONTEXT || {};
    var shopify = window.Shopify || {};
    var country = String(supplied.country || shopify.country || '').toUpperCase();
    var locale = String(supplied.locale || shopify.locale || 'nl').toLowerCase();
    var currency = String(supplied.currency || (shopify.currency && shopify.currency.active) || '').toUpperCase();
    // United States (main market since 2026-10-28): Shop B owns the USD checkout under
    // /en-us. Only the country or the US path selects it, never Shop A's own currency.
    if (country === 'US' || /^\/en-us(?:\/|$)/i.test(location.pathname)) {
      return {
        country: 'US',
        locale: 'en',
        currency: 'USD',
        root: supplied.usRoot || CART_DOMAIN + '/en-us'
      };
    }
    var isSwiss = country === 'CH' || currency === 'CHF' || /^\/de-ch(?:\/|$)/i.test(location.pathname);
    // United Kingdom: Shop B owns the real GBP checkout under /en-gb (fixed rate 1.0).
    // Shop A's shop currency is GBP, so GBP alone says nothing about the market:
    // only the country (or the UK path) selects the UK checkout. NL/BE stay EUR.
    var isUK = !isSwiss && (country === 'GB' || /^\/en-gb(?:\/|$)/i.test(location.pathname) || (!country && currency === 'GBP'));
    if (isUK) {
      return {
        country: 'GB',
        locale: 'en',
        currency: 'GBP',
        root: supplied.ukRoot || CART_DOMAIN + '/en-gb'
      };
    }
    return {
      country: isSwiss ? 'CH' : (country || 'NL'),
      locale: isSwiss ? 'de' : (locale.indexOf('de') === 0 ? 'de' : 'nl'),
      currency: isSwiss ? 'CHF' : 'EUR',
      root: isSwiss ? (supplied.swissRoot || CART_DOMAIN + '/de-ch') : CART_DOMAIN
    };
  }

  function copy(){
    return COPY[checkoutContext().locale] || COPY.nl;
  }

  // Shop A cannot expose native CHF because its payment gateway only supports
  // the shop currency (EUR). It is browse-only and Shop B owns the real CHF
  // checkout. In CH, render the numerically identical fixed-rate prices as CHF
  // while leaving Shopify's internal Shop-A cart currency untouched.
  const EURO_AMOUNT_PATTERN = '(?:\\d{1,3}(?:\\.\\d{3})+(?:,\\d{1,2})?|\\d+(?:[,.]\\d{1,2})?)';
  const EURO_PREFIX_PATTERN = new RegExp('€\\s*(' + EURO_AMOUNT_PATTERN + ')(?:\\s*EUR)?', 'g');
  const EURO_SUFFIX_PATTERN = new RegExp('(' + EURO_AMOUNT_PATTERN + ')\\s*€(?:\\s*EUR)?', 'g');
  const EUR_PREFIX_PATTERN = new RegExp('\\bEUR\\s*(' + EURO_AMOUNT_PATTERN + ')', 'g');
  const EUR_SUFFIX_PATTERN = new RegExp('(' + EURO_AMOUNT_PATTERN + ')\\s*EUR\\b', 'g');
  const ACCESSIBLE_CURRENCY_ATTRIBUTES = ['aria-label', 'aria-valuetext', 'title', 'data-text'];
  const BLOCKED_CURRENCY_TAGS = /^(SCRIPT|STYLE|NOSCRIPT|TEXTAREA|CODE|PRE)$/;
  const LOCALIZATION_ANCESTOR_SELECTOR = 'localization-form, form.localization-form, .localization-form';
  const CH_LOCALIZATION_SELECTOR = [
    'localization-form button.localization-form__select span',
    'form.localization-form button.localization-form__select span',
    '.localization-form button.localization-form__select span',
    'localization-form [data-value="CH"]',
    'form.localization-form [data-value="CH"]',
    '.localization-form [data-value="CH"]',
    'select[name="country_code"] option[value="CH"]'
  ].join(',');
  const GB_LOCALIZATION_SELECTOR = [
    'localization-form button.localization-form__select span',
    'form.localization-form button.localization-form__select span',
    '.localization-form button.localization-form__select span',
    'localization-form [data-value="GB"]',
    'form.localization-form [data-value="GB"]',
    '.localization-form [data-value="GB"]',
    'select[name="country_code"] option[value="GB"]'
  ].join(',');

  const NLBE_LOCALIZATION_SELECTOR = [
    'localization-form button.localization-form__select span',
    'form.localization-form button.localization-form__select span',
    '.localization-form button.localization-form__select span',
    'localization-form [data-value="NL"]',
    'form.localization-form [data-value="NL"]',
    '.localization-form [data-value="NL"]',
    'localization-form [data-value="BE"]',
    'form.localization-form [data-value="BE"]',
    '.localization-form [data-value="BE"]',
    'select[name="country_code"] option[value="NL"]',
    'select[name="country_code"] option[value="BE"]'
  ].join(',');

  function localizationSelector() {
    var country = checkoutContext().country;
    if (country === 'GB') return GB_LOCALIZATION_SELECTOR;
    if (country === 'CH') return CH_LOCALIZATION_SELECTOR;
    return NLBE_LOCALIZATION_SELECTOR;
  }

  function internalCurrency() {
    var supplied = window.VM_CHECKOUT_CONTEXT || {};
    var shopify = window.Shopify || {};
    return String(supplied.internalCurrency || (shopify.currency && shopify.currency.active) || '').toUpperCase();
  }

  // Shop A's shop currency is GBP (UK is the main market). NL/BE pay in EUR on Shop B
  // at the numerically identical fixed price, so Shop A's pound amounts are shown as
  // euros in Dutch format there (£1,299.90 -> €1.299,90).
  const POUND_AMOUNT_PATTERN = '(?:\\d{1,3}(?:,\\d{3})+(?:\\.\\d{1,2})?|\\d+(?:\\.\\d{1,2})?)';
  const POUND_PREFIX_PATTERN = new RegExp('£\\s*(' + POUND_AMOUNT_PATTERN + ')(?:\\s*GBP)?', 'g');
  const GBP_PREFIX_PATTERN = new RegExp('\\bGBP\\s*(' + POUND_AMOUNT_PATTERN + ')', 'g');
  const GBP_SUFFIX_PATTERN = new RegExp('(' + POUND_AMOUNT_PATTERN + ')\\s*GBP\\b', 'g');

  function euroCurrencyText(value) {
    if (!value || (value.indexOf('£') === -1 && !/\bGBP\b/.test(value))) return value;

    function euroAmount(amount) {
      var parts = amount.split('.');
      var whole = parts[0].replace(/,/g, '.');
      return parts.length > 1 ? whole + ',' + parts[1] : whole;
    }

    return String(value)
      .replace(POUND_PREFIX_PATTERN, function(_match, amount){ return '€' + euroAmount(amount); })
      .replace(GBP_PREFIX_PATTERN, function(_match, amount){ return '€' + euroAmount(amount); })
      .replace(GBP_SUFFIX_PATTERN, function(_match, amount){ return '€' + euroAmount(amount); })
      .replace(/\bGBP\s*£|£\s*GBP\b/g, 'EUR €')
      .replace(/\bGBP\b/g, 'EUR')
      .replace(/£/g, '€');
  }

  function swissCurrencyText(value) {
    if (!value || (value.indexOf('€') === -1 && !/\bEUR\b/.test(value))) return value;

    function swissAmount(amount) {
      if (amount.indexOf(',') !== -1) return amount.replace(/\./g, "'").replace(',', '.');
      var dotParts = amount.split('.');
      if (dotParts.length > 1 && dotParts.slice(1).every(function(part){ return part.length === 3; })) {
        return dotParts.join("'");
      }
      return amount;
    }

    return String(value)
      .replace(EURO_PREFIX_PATTERN, function(_match, amount){ return 'CHF ' + swissAmount(amount); })
      .replace(EURO_SUFFIX_PATTERN, function(_match, amount){ return 'CHF ' + swissAmount(amount); })
      .replace(EUR_PREFIX_PATTERN, function(_match, amount){ return 'CHF ' + swissAmount(amount); })
      .replace(EUR_SUFFIX_PATTERN, function(_match, amount){ return 'CHF ' + swissAmount(amount); })
      .replace(/\bEUR\s*€|€\s*EUR\b/g, 'CHF')
      .replace(/\bEUR\b/g, 'CHF')
      .replace(/€/g, 'CHF')
      .replace(/CHF(?:\s|\u00a0)+CHF/g, 'CHF');
  }

  // UK: same fixed-rate number, shown as pounds in British format (69,90 € -> £69.90).
  function ukCurrencyText(value) {
    if (!value || (value.indexOf('€') === -1 && !/\bEUR\b/.test(value))) return value;

    function ukAmount(amount) {
      if (amount.indexOf(',') !== -1) return amount.replace(/\./g, ',').replace(/,(\d{1,2})$/, '.$1');
      var dotParts = amount.split('.');
      if (dotParts.length > 1 && dotParts.slice(1).every(function(part){ return part.length === 3; })) {
        return dotParts.join(',');
      }
      return amount;
    }

    return String(value)
      .replace(EURO_PREFIX_PATTERN, function(_match, amount){ return '£' + ukAmount(amount); })
      .replace(EURO_SUFFIX_PATTERN, function(_match, amount){ return '£' + ukAmount(amount); })
      .replace(EUR_PREFIX_PATTERN, function(_match, amount){ return '£' + ukAmount(amount); })
      .replace(EUR_SUFFIX_PATTERN, function(_match, amount){ return '£' + ukAmount(amount); })
      .replace(/\bEUR\s*€|€\s*EUR\b/g, 'GBP £')
      .replace(/\bEUR\b/g, 'GBP')
      .replace(/€/g, '£');
  }

  function displayCurrencyText(value) {
    var country = checkoutContext().country;
    // US: Shop A's own USD prices are shown as they are.
    if (country === 'US') return value;
    if (country === 'GB') return ukCurrencyText(value);
    // CH: pound amounts (GBP shop currency) go through the euro form first.
    if (country === 'CH') return swissCurrencyText(euroCurrencyText(value));
    return euroCurrencyText(value);
  }

  function displayCurrencyCode() {
    var country = checkoutContext().country;
    if (country === 'US') return '';
    if (country === 'GB') return 'GBP';
    if (country === 'CH') return 'CHF';
    return internalCurrency() === 'GBP' ? 'EUR' : '';
  }

  function elementForNode(node) {
    if (!node) return null;
    if (node.nodeType === 1) return node;
    return node.parentElement || null;
  }

  function isBlockedCurrencyNode(node) {
    var element = elementForNode(node);
    return !element || BLOCKED_CURRENCY_TAGS.test(element.tagName);
  }

  function isInsideLocalization(node) {
    var element = elementForNode(node);
    return !!(element && element.closest && element.closest(LOCALIZATION_ANCESTOR_SELECTOR));
  }

  function convertTextNode(node, allowLocalization) {
    if (!node || node.nodeType !== 3 || isBlockedCurrencyNode(node)) return;
    if (!allowLocalization && isInsideLocalization(node)) return;
    var converted = displayCurrencyText(node.nodeValue);
    if (converted !== node.nodeValue) node.nodeValue = converted;
  }

  function convertAccessibleAttributes(element, allowLocalization) {
    if (!element || element.nodeType !== 1 || BLOCKED_CURRENCY_TAGS.test(element.tagName)) return;
    if (!allowLocalization && isInsideLocalization(element)) return;
    ACCESSIBLE_CURRENCY_ATTRIBUTES.forEach(function(attribute){
      if (!element.hasAttribute(attribute)) return;
      var current = element.getAttribute(attribute);
      var converted = displayCurrencyText(current);
      if (converted !== current) element.setAttribute(attribute, converted);
    });
  }

  function convertSubtree(root, allowLocalization) {
    if (!root) return;
    if (root.nodeType === 3) {
      convertTextNode(root, allowLocalization);
      return;
    }
    if (root.nodeType !== 1 && root.nodeType !== 9 && root.nodeType !== 11) return;

    if (root.nodeType === 1) convertAccessibleAttributes(root, allowLocalization);
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_TEXT);
    var node;
    while ((node = walker.nextNode())) {
      if (node.nodeType === 3) convertTextNode(node, allowLocalization);
      else convertAccessibleAttributes(node, allowLocalization);
    }
  }

  function matchingLocalizationNodes(root) {
    var matches = [];
    if (!root || (root.nodeType !== 1 && root.nodeType !== 9 && root.nodeType !== 11)) return matches;
    if (root.nodeType === 1) {
      if (root.matches && root.matches(localizationSelector())) matches.push(root);
      var closest = root.closest && root.closest(localizationSelector());
      if (closest && matches.indexOf(closest) === -1) matches.push(closest);
    }
    if (root.querySelectorAll) {
      root.querySelectorAll(localizationSelector()).forEach(function(node){ matches.push(node); });
    }
    return matches;
  }

  function renderSwissCurrency(root) {
    convertSubtree(root, false);
    // The CH page also lists NL and BE. Convert the current CH label and the
    // explicit CH option only; the NL/BE option labels must remain EUR.
    matchingLocalizationNodes(root).forEach(function(node){ convertSubtree(node, true); });
  }

  function startSwissCurrencyRenderer() {
    var displayCurrency = displayCurrencyCode();
    if (!displayCurrency || window.__vmChfRendererStarted) return;
    window.__vmChfRendererStarted = true;
    document.documentElement.setAttribute('data-vm-display-currency', displayCurrency);

    var root = document.body || document.documentElement;
    renderSwissCurrency(root);
    var observer = new MutationObserver(function(records){
      records.forEach(function(record){
        if (record.type === 'characterData') {
          convertTextNode(record.target, false);
          if (isInsideLocalization(record.target)) {
            matchingLocalizationNodes(document).forEach(function(node){ convertSubtree(node, true); });
          }
          return;
        }
        if (record.type === 'attributes') {
          convertAccessibleAttributes(record.target, false);
          matchingLocalizationNodes(record.target).forEach(function(node){ convertSubtree(node, true); });
          return;
        }
        record.addedNodes.forEach(renderSwissCurrency);
        matchingLocalizationNodes(record.target).forEach(function(node){ convertSubtree(node, true); });
      });
    });
    observer.observe(root, {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true,
      attributeFilter: ACCESSIBLE_CURRENCY_ATTRIBUTES
    });
    window.__vmChfObserver = observer;
    window.VM_CHF_RENDERER_READY = true;
  }

  function getCookie(n){
    const m = document.cookie.match(new RegExp('(?:^|;\\s*)'+n.replace(/[.*+?^${}()|[\]\\]/g,'\\$&')+'=([^;]+)'));
    return m ? decodeURIComponent(m[1]) : null;
  }

  // Last ad click (UTMs, fbc, eid) in a 7-day first-party cookie. sessionStorage is
  // per tab and was gone at checkout in in-app browser sessions (#1304/#1306).
  var ATTR_COOKIE = 'rc_attr';
  var ATTR_KEYS = ['utm_source','utm_medium','utm_campaign','utm_term','utm_content',
    'utm_angle','utm_id','ad_id','adset_id','placement','site_source_name','fbclid'];
  function ssGet(k){ try { return sessionStorage.getItem(k); } catch(e){ return null; } }
  function attrRead(){ try { return JSON.parse(getCookie(ATTR_COOKIE) || '{}') || {}; } catch(e){ return {}; } }
  function attrGet(k){ return attrRead()[k] || null; }
  function attrWrite(a){
    document.cookie = ATTR_COOKIE + '=' + encodeURIComponent(JSON.stringify(a)) + ';path=/;max-age=' + (7*86400) + ';SameSite=Lax';
  }

  function getMetaCookies(){
    var fbc = getCookie('_fbc');
    var fbp = getCookie('_fbp');

    // Fallback: construct _fbc from fbclid in URL if cookie not set yet
    if (!fbc) {
      var params = new URLSearchParams(location.search);
      var fbclid = params.get('fbclid');
      if (fbclid) {
        fbc = 'fb.1.' + Date.now() + '.' + fbclid;
      }
    }

    // Fallback: check sessionStorage (we cache on every page load)
    if (!fbc) fbc = ssGet('rc_fbc') || attrGet('fbc');
    if (!fbp) fbp = ssGet('rc_fbp');

    // Read rc_eid from cookie (set by Store A pixel), else the ad-click backup, else mint one
    var eid = getCookie('rc_eid') || attrGet('eid');
    if (!eid) {
      eid = Date.now().toString(36) + Math.random().toString(36).substr(2,9);
      document.cookie = 'rc_eid=' + eid + ';path=/;max-age=' + (365*86400) + ';SameSite=Lax';
    }

    return { fbc: fbc || null, fbp: fbp || null, eid: eid || null };
  }

  // Cache Meta cookies on every page load (survives async pixel load timing)
  try {
    var _fbc = getCookie('_fbc');
    var _fbp = getCookie('_fbp');
    if (_fbc) sessionStorage.setItem('rc_fbc', _fbc);
    if (_fbp) sessionStorage.setItem('rc_fbp', _fbp);
    var _params = new URLSearchParams(location.search);
    var _fbclid = _params.get('fbclid');
    if (_fbclid && !_fbc) {
      var constructed = 'fb.1.' + Date.now() + '.' + _fbclid;
      sessionStorage.setItem('rc_fbc', constructed);
    }
    // Cache UTMs in sessionStorage (survive navigation within Store A)
    ['utm_source','utm_medium','utm_campaign','utm_term','utm_content',
     'utm_angle','utm_id','ad_id','adset_id','placement','site_source_name'].forEach(function(k){
      var v = _params.get(k);
      if (v) sessionStorage.setItem('rc_' + k, v);
    });
  } catch(e){}
  try {
    var _p = new URLSearchParams(location.search);
    if (_p.get('utm_campaign') || _p.get('fbclid')) {
      var _a = {};
      ATTR_KEYS.forEach(function(k){ var v = _p.get(k); if (v) _a[k] = v; });
      var _c = getCookie('_fbc') || (_p.get('fbclid') ? 'fb.1.' + Date.now() + '.' + _p.get('fbclid') : '');
      if (_c) _a.fbc = _c;
      var _e = getCookie('rc_eid');
      if (_e) _a.eid = _e;
      attrWrite(_a);
      // Pixel may set rc_eid/_fbc after us
      setTimeout(function(){
        var a = attrRead();
        if (a.utm_campaign !== _a.utm_campaign || a.fbclid !== _a.fbclid) return;
        var e2 = getCookie('rc_eid'), c2 = getCookie('_fbc');
        if ((e2 && !a.eid) || (c2 && c2 !== a.fbc)) { if (e2 && !a.eid) a.eid = e2; if (c2) a.fbc = c2; attrWrite(a); }
      }, 3000);
    }
  } catch(e){}
  try {
    // Retry after pixel has had time to set cookies
    setTimeout(function(){
      var fbp2 = getCookie('_fbp');
      if (fbp2) sessionStorage.setItem('rc_fbp', fbp2);
      var fbc2 = getCookie('_fbc');
      if (fbc2) sessionStorage.setItem('rc_fbc', fbc2);
      // If fbevents.js was blocked and _fbp still not set, generate one
      if (!getCookie('_fbp') && !sessionStorage.getItem('rc_fbp')) {
        var genFbp = 'fb.1.' + Date.now() + '.' + Math.floor(Math.random() * 1e16);
        document.cookie = '_fbp=' + genFbp + ';path=/;max-age=' + (90*86400) + ';SameSite=Lax';
        sessionStorage.setItem('rc_fbp', genFbp);
      }
    }, 3000);
  } catch(e){}

  // Report redirect errors to CAPI server for monitoring
  function reportError(reason, details) {
    try {
      var capiBase = document.querySelector('[data-capi-url]');
      var url = capiBase ? capiBase.getAttribute('data-capi-url') : '';
      if (!url) {
        // Fallback: try to find it from the pixel snippet's beacon calls
        var scripts = document.querySelectorAll('script');
        for (var i = 0; i < scripts.length; i++) {
          var m = scripts[i].textContent.match(/var\s+(?:capiBase|pvCapi)\s*=\s*'(https:\/\/[^']+)'/);
          if (m) { url = m[1]; break; }
        }
      }
      if (url) {
        navigator.sendBeacon && navigator.sendBeacon(url + '/event/redirect-error', JSON.stringify({
          reason: reason,
          details: details || '',
          url: location.href,
          timestamp: Date.now()
        }));
      }
    } catch(e) {}
    console.error('[redirect] ' + reason, details || '');
  }

  function buildQS(extra, context){
    var keep = new URLSearchParams(location.search);
    var qs = new URLSearchParams();
    // Read UTMs from URL first, fallback to sessionStorage (cached from landing page)
    ['utm_source','utm_medium','utm_campaign','utm_term','utm_content',
     'utm_angle','utm_id','ad_id','adset_id','placement','site_source_name',
     'fbclid','gclid'].forEach(function(k){
      var v = keep.get(k) || ssGet('rc_' + k) || attrGet(k);
      if (v) qs.set(k, v);
    });
    // The cross-domain hop must not let Shopify fall back to NL/EUR.
    qs.set('country', context.country);
    qs.set('locale', context.locale);
    qs.set('attributes[_vm_country]', context.country);
    qs.set('attributes[_vm_locale]', context.locale);
    qs.set('attributes[_vm_currency]', context.currency);
    if (extra.fbc) { qs.set('rc_fbc', extra.fbc); qs.set('attributes[_rc_fbc]', extra.fbc); }
    if (extra.fbp) { qs.set('rc_fbp', extra.fbp); qs.set('attributes[_rc_fbp]', extra.fbp); }
    if (extra.eid) { qs.set('rc_eid', extra.eid); qs.set('attributes[_rc_eid]', extra.eid); }
    ['utm_campaign','utm_content','utm_term','utm_angle','utm_id','ad_id','adset_id','placement'].forEach(function(k){
      var v = keep.get(k) || ssGet('rc_' + k) || attrGet(k);
      if (v) qs.set('attributes[_rc_' + k + ']', v);
    });
    return qs.toString();
  }

  function redirectToCart(pairs, ids){
    var context = checkoutContext();
    var path = pairs.join(',');
    var q = buildQS(ids, context);
    var root = context.root.replace(/\/$/, '');
    var url = root + '/cart/' + path + '?' + q;
    location.href = url;
  }

  function showError(btn, msg) {
    btn.disabled = false;
    btn.textContent = msg;
    btn.style.backgroundColor = '#c0392b';
    btn.style.color = '#fff';
    setTimeout(function(){ btn.style.backgroundColor = ''; btn.style.color = ''; btn.textContent = copy().checkout; }, 4000);
  }

  function attachCheckoutOverride(btn){
    if (!btn || btn.classList.contains('redirect-bound')) return;
    btn.classList.add('redirect-bound');
    btn.addEventListener('click', async function(e){
      e.preventDefault(); e.stopPropagation(); btn.disabled = true;
      btn.textContent = copy().redirecting;

      if (typeof variantMap === 'undefined') {
        reportError('variantMap_missing', 'variantMap not loaded on page');
        showError(btn, copy().error);
        return;
      }

      try {
        var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        var cart = await fetch(root + 'cart.js').then(function(r){
          if (!r.ok) throw new Error('cart.js HTTP ' + r.status);
          return r.json();
        });
        if (!cart.items || !cart.items.length) { location.href = root + 'cart'; return; }

        var merged = {};
        var unmapped = [];
        cart.items.forEach(function(it){
          var to = variantMap[String(it.variant_id)];
          if (to) {
            merged[to] = (merged[to] || 0) + it.quantity;
          } else {
            unmapped.push(it.variant_id + ' (' + (it.title || it.sku || '?') + ')');
          }
        });

        var pairs = Object.entries(merged).map(function(e){ return e[0]+':'+e[1]; });
        if (!pairs.length) {
          reportError('no_mapping', 'Cart items not in variantMap: ' + unmapped.join(', '));
          showError(btn, copy().unavailable);
          return;
        }

        // Fail closed: silently dropping even one line item is never acceptable.
        if (unmapped.length > 0) {
          reportError('partial_mapping', 'Unmapped variants: ' + unmapped.join(', '));
          showError(btn, copy().partial);
          return;
        }

        var ids = getMetaCookies();
        redirectToCart(pairs, ids);
      } catch (err){
        reportError('redirect_exception', err.message || String(err));
        showError(btn, copy().error);
      }
    });
  }

  var bindTimer;
  function debouncedBind(){ clearTimeout(bindTimer); bindTimer = setTimeout(bind, 50); }

  function bind(){
    ['#CartDrawer-Checkout','button[name="checkout"]','.cart__checkout-button','form[action="/checkout"] button[type="submit"]','a[href="/checkout"]']
      .forEach(function(sel){ document.querySelectorAll(sel).forEach(attachCheckoutOverride); });
  }
  document.addEventListener('DOMContentLoaded', bind);
  document.addEventListener('shopify:section:load', bind);
  document.addEventListener('shopify:cart:updated', bind);
  window.addEventListener('pageshow', bind);
  new MutationObserver(debouncedBind).observe(document.body,{childList:true,subtree:true});
  startSwissCurrencyRenderer();
})();
